// Dependencies
import { baanRueJaiClient } from "../../../../dependencies"

// LINE Notify Use Cases
export const useCases = baanRueJaiClient.admin.lineNotify